export enum RequestStatusEnum {
  Success = 'success',
  Error = 'error',
  Loading = 'loading',
  Idle = 'idle',
}
